export const customListUserExternalNotificationSettings = /* GraphQL */ `
  query CustomListUserExternalNotificationSettings(
    $filter: ModelUserExternalNotificationSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserExternalNotificationSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        isEnabled
      }
      nextToken
    }
  }
`;
